import { MESSAGE } from '@vindr/services/constants/message.constant';
import { messageError } from '@vindr/utils/formatText';
import { UseMutationResult } from '@tanstack/react-query';
import { FormInstance } from 'antd/lib/form';

interface HandleSaveParams {
  message: any;
  form?: FormInstance<any>;
  createParams?: (values: any) => any;
  editParams?: (values: any) => any;
  deleteParams?: any;
  type: 'edit' | 'create' | 'delete';
  mutate: {
    create?: UseMutationResult<any, unknown, unknown, unknown>['mutate'];
    update?: UseMutationResult<any, unknown, unknown, unknown>['mutate'];
    delete?: UseMutationResult<any, unknown, unknown, unknown>['mutate'];
  };
  t?: (key: string) => string;
  onDone?: any;
  code?: {
    created?: keyof typeof MESSAGE.SUCCESS;
    updated?: keyof typeof MESSAGE.SUCCESS;
    deleted?: keyof typeof MESSAGE.SUCCESS;
  };
}

const handleSave = (props: HandleSaveParams) => {
  const {
    message,
    form,
    createParams,
    editParams,
    deleteParams,
    type,
    mutate,
    t,
    onDone,
    code: { created, updated, deleted },
  } = props;

  const mutateCreate = mutate.create;
  const mutateUpdate = mutate.update;
  const mutateDelete = mutate.delete;

  const onError = (error: any) => {
    const msg = messageError(error);

    message.error(t ? t(msg) : msg);
  };

  const onSuccess = (messageCode: keyof typeof MESSAGE.SUCCESS) => {
    if (!messageCode) return;
    const msg = MESSAGE.SUCCESS[messageCode];

    message.success(t ? t(msg) : msg);
    form?.resetFields();
  };

  switch (type) {
    case 'create':
      form.validateFields().then(async (values) => {
        mutateCreate(createParams?.(values) || values, {
          onSuccess: (val) => {
            onSuccess(created);
            onDone?.(val);
          },
          onError,
        });
      });
      break;

    case 'edit': {
      form.validateFields().then(async (values) => {
        mutateUpdate(editParams(values), {
          onSuccess: () => {
            onSuccess(updated);
            onDone?.();
          },
          onError,
        });
      });
      break;
    }

    case 'delete':
      mutateDelete(deleteParams, {
        onSuccess: () => {
          onSuccess(deleted);
          onDone?.();
        },
        onError,
      });
      break;
    default:
      throw new Error('Invalid type');
  }
};

export default handleSave;
